import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Row,
    Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem
} from "reactstrap";
// core components
import React, { useState, useEffect } from 'react';
import { Redirect } from "react-router-dom";
import memberService from "../service/APIService";
import "../../views/LoginComponents/login.css"
import { ToastsStore } from "react-toasts";
import forward from "assets/img/yamahaIcons/forward.svg"
import back from "assets/img/yamahaIcons/back.svg"
import firebase from "utils/firebase";
import {t} from "i18next";

const MyProductDetail = (props) => {
    const [userId, setUserId] = useState(sessionStorage.getItem('userId'))
    const [memberPoints, setMemberPoints] = useState({})
    const [productsData, setProductsData] = useState()
    const [searchedProductsData, setSearchedProductsData] = useState()
    const [productInfo, setProductInfo] = useState(props && props.location && props.location.state && props.location.state.productsData)
    const [initialProductImage, setInitialProductImage] = useState(props && props.location && props.location.state && props.location.state.productsData.images && props.location.state.productsData.images[0])
    const [productImageUrls, setProductImageUrls] = useState(props && props.location && props.location.state && props.location.state.productsData.images && props.location.state.productsData.images)

    const [nextId, setNextId] = React.useState(0)
    const [qtyInStock, setQtyInStock] = React.useState(1)

    const newProductData = []
    const [dropdownOpen1, setDropdownOpen1] = useState(false);
    const [dropdownOpen2, setDropdownOpen2] = useState(false);
    const [isProductInBag, setIsProductInBag] = useState(false);
    const [isVariationProduct, setVariationProduct] = useState(false);
    const [isProceed, setProceedToCart] = useState(false);
    const [attribute1List, setAttribute1List] = useState([]);
    const [attribute2List, setAttribute2List] = useState([]);
    const [selectedAttribute1, setSelectedAttribute1] = useState(null);
    const [selectedAttribute2, setSelectedAttribute2] = useState(null);

    const [variationProductData, setVariationProductData] = useState(null)

    const [variationProductQty, setVariationProductQty] = React.useState(1)
    const [availableVariations, setAvailableVariations] = useState();
    const [productsInBag, setProductsInBag] = useState([]);

    const [showError, setShowError] = useState(false);

    const toggle1 = () => setDropdownOpen1(prevState => !prevState);
    const toggle2 = () => setDropdownOpen2(prevState => !prevState);


    useEffect(() => {
        firebase.logEventForAnalytics("Product Detail")
        getMemberPointsBalance()
        getGenbluProducts()
        let initialAttribute1List = productInfo.attributes[0]
        let initialAttribute2List = productInfo.attributes[1]
        let list1 = []
        let list2 = []
        let availableVariations = []
        let firstValue = ""
        let secondValue = ""

        if (productInfo && productInfo.variations && productInfo.variations.length > 0) {
            firstValue = productInfo.variations && productInfo.variations[0] && productInfo.variations[0].attributes &&
                productInfo.variations[0].attributes[0] && productInfo.variations[0].attributes[0].option
            secondValue = productInfo.variations && productInfo.variations[0] && productInfo.variations[0].attributes &&
                productInfo.variations[0].attributes[1] && productInfo.variations[0].attributes[1].option
        }


        productInfo.variations && productInfo.variations.forEach(aVariation => {

            if (aVariation && aVariation.attributes && aVariation.attributes.length > 1) {
                setSelectedAttribute1(firstValue)
                setSelectedAttribute2(secondValue)
                availableVariations.push({ [aVariation.attributes[0].name]: aVariation.attributes[0].option, [aVariation.attributes[1].name]: aVariation.attributes[1].option })
            }
            if (aVariation && aVariation.attributes && aVariation.attributes.length === 1) {
                setSelectedAttribute1(firstValue)
                aVariation.attributes.forEach(aVariation => {
                    availableVariations.push({ [aVariation.name]: aVariation.option })
                })
            }
            if (aVariation.attributes.length > 1) {
                if (aVariation.attributes[0].option === firstValue && aVariation.attributes[1].option === secondValue) {
                    setVariationProductData(aVariation)
                }
            }
            else if (aVariation.attributes.length === 1) {
                if (aVariation.attributes && aVariation.attributes[0].option === firstValue) {
                    setVariationProductData(aVariation)
                }
            }

            aVariation.attributes && aVariation.attributes.forEach(aData => {

                if (initialAttribute2List && initialAttribute2List.name !== aData.name) {
                    initialAttribute2List.terms.forEach(aTerm => {
                        // list1.push({ name: aTerm.name })
                    })
                }
                else if (initialAttribute2List && initialAttribute2List.name === aData.name) {
                    list1.push({ name: aData.option })
                }
                if (initialAttribute1List && initialAttribute1List.name !== aData.name) {
                    initialAttribute1List.terms.forEach(aTerm => {
                    })
                }
                else if (initialAttribute1List && initialAttribute1List.name === aData.name) {
                    list2.push({ name: aData.option })
                }
            })
        })
        setAvailableVariations(availableVariations)
        const uniqueList1 = [];
        const uniqueList2 = [];

        list2.map(x => uniqueList1.filter(a => a.name == x.name).length > 0 ? null : uniqueList1.push(x));
        list1.map(x => uniqueList2.filter(a => a.name == x.name).length > 0 ? null : uniqueList2.push(x));

        setAttribute2List(uniqueList2)
        setAttribute1List(uniqueList1)
        if (uniqueList2 && uniqueList2.length === 0 && uniqueList1 && uniqueList1.length === 0)
            setVariationProduct(false)
        else {
            setVariationProduct(true)

        }


    }, [])

    const getMemberPointsBalance = () => {
        let request = {
            fetchLimit: 1000,
            paginationBookmark: 0
        }
        memberService.getMemberPointsBalance(userId, request).then(response => {
            setMemberPoints(response.data)
        })
    }

    const getGenbluProducts = () => {
        memberService.getGenbluProducts().then(response => {
            response.data && response.data.forEach(aData => {
                newProductData.push(aData)

            })
            fetchWishListedProducts()
            fetchProductsInBag()

        })
    }

    const handleWishList = (product) => {
        product.isWishlisted = !product.isWishlisted
        memberService.addProductToWishlist(product.id).then(response => {
            // setProductInfo({ ...product })
            getGenbluProducts()
            ToastsStore.success(t("Product added to wishlist successfully."));

        })
    }

    const clearWishList = (product) => {
        product.isWishlisted = !product.isWishlisted
        memberService.removeFromWishlist(product.id).then((response) => {
            getGenbluProducts()
            // setProductInfo({ ...product })
            ToastsStore.success(t("Product removed from wishlist successfully."));

        })
    }

    const fetchWishListedProducts = () => {
        memberService.fetchWishlistedProducts().then(response => {
            let whiteListedIds = [];
            response && response.data.map(aData => { whiteListedIds.push(aData.id) })
            newProductData && newProductData.forEach(aData => {
                aData.isWishlisted = whiteListedIds.includes(aData.id)
                return aData
            })
            setProductsData(newProductData)
            setSearchedProductsData(newProductData)
        })
    }


    const handlePrev = () => {
        if (nextId !== 0) {
            setNextId(nextId - 1)
            let initialProductImage = productImageUrls[nextId - 1]
            setInitialProductImage(initialProductImage)
        }

    }
    const handleNext = () => {
        if (nextId < (productImageUrls.length)) {
            setNextId(nextId + 1)
            let initialProductImage = productImageUrls[nextId + 1]
            setInitialProductImage(initialProductImage)
        }
        else if (nextId === productImageUrls.length) {
            setNextId(nextId)
            let initialProductImage = productImageUrls[nextId]
            setInitialProductImage(initialProductImage)
        }
    }

    const handleReduceQty = () => {
        if (qtyInStock !== 1) {
            let qtInStock = qtyInStock - 1;
            setQtyInStock(qtInStock)
        }

    }
    const handleIncreaseQty = () => {
        if (qtyInStock < productInfo.stockQuantity) {
            let qtInStock = qtyInStock + 1;
            setQtyInStock(qtInStock)
        }

    }

    const handleReduceVariationQty = () => {
        if (variationProductQty !== 1) {
            let qtInStock = variationProductQty - 1;
            setVariationProductQty(qtInStock)
        }

    }

    const handleIncreaseVariationQty = () => {
        if (variationProductQty < variationProductData.stock_quantity) {

            let qtInStock = variationProductQty + 1;
            setVariationProductQty(qtInStock)
        }
    }

    const handleAttributeSelect = (event, type, type1) => {
        setIsProductInBag(false)
        if (event.target.innerText !== 'Select') {
            let selectedVariations;
            if (selectedAttribute2 !== null)
                selectedVariations = { [type]: event.target.innerText, [type1]: selectedAttribute2 }
            else
                selectedVariations = { [type]: event.target.innerText }
            if (JSON.stringify(availableVariations).includes(JSON.stringify(selectedVariations))) {
                setShowError(false)

            }
            else {
                setShowError(true)
            }
            setSelectedAttribute1(event.target.innerText)
            let newAttributes = []
            for (const [key, value] of Object.entries(selectedVariations)) {
                newAttributes.push({ name: `${key}`, option: `${value}` })

            }
            let data;
            productInfo.variations.forEach(aVar => {
                if (JSON.stringify(aVar.attributes) === JSON.stringify(newAttributes)) {
                    data = aVar
                }
            })
            if (data && data.image && data.image.src) {
                let productImages = productImageUrls
                productImages.push(data.image.src)
                setProductImageUrls(productImages)
                setInitialProductImage(data.image.src)
            }
            if (data && productsInBag.includes(data.id)) {
                setIsProductInBag(true)
            }
            else { setIsProductInBag(false) }
            setVariationProductData(data)
            setVariationProduct(true)
            setVariationProductQty(1)
        }
    }
    const handleAttribute1Select = (event, type, type1) => {
        setIsProductInBag(false)
        if (event.target.innerText !== 'Select') {
            let selectedVariations = { [type1]: selectedAttribute1, [type]: event.target.innerText }
            if (JSON.stringify(availableVariations).includes(JSON.stringify(selectedVariations))) {
                setShowError(false)

            }
            else {
                setShowError(true)
            }
            setSelectedAttribute2(event.target.innerText)
            let newAttributes = []
            for (const [key, value] of Object.entries(selectedVariations)) {
                newAttributes.push({ name: `${key}`, option: `${value}` })

            }
            let data;
            productInfo.variations.forEach(aVar => {
                if (JSON.stringify(aVar.attributes) === JSON.stringify(newAttributes)) {
                    data = aVar
                }
            })
            if (data && productsInBag.includes(data.id)) {
                setIsProductInBag(true)
            }
            else { setIsProductInBag(false) }
            if (data && data.image && data.image.src) {
                let productImages = productImageUrls
                productImages.push(data.image.src)
                setProductImageUrls(productImages)
                setInitialProductImage(data.image.src)
            }

            setVariationProductData(data)
            setVariationProduct(true)
            setVariationProductQty(1)

        }
    }

    const fetchProductsInBag = () => {
        let productsInBag = []
        memberService.fetchProductsInCart().then(response => {
            response.data && response.data.forEach(aProduct => {
                if (aProduct.variationsInCart && aProduct.variationsInCart.length === 0)
                    productsInBag.push(aProduct.id)
                else {
                    aProduct.variationsInCart && aProduct.variationsInCart.map(aVariation => { productsInBag.push(aVariation.variationId) })
                }
            })
            setProductsInBag(productsInBag)
            let vafriationProduct = null
            let firstValue = ""
            let secondValue = ""

            if (productInfo && productInfo.variations && productInfo.variations.length > 0) {
                firstValue = productInfo.variations && productInfo.variations[0] && productInfo.variations[0].attributes &&
                    productInfo.variations[0].attributes[0] && productInfo.variations[0].attributes[0].option
                secondValue = productInfo.variations && productInfo.variations[0] && productInfo.variations[0].attributes &&
                    productInfo.variations[0].attributes[1] && productInfo.variations[0].attributes[1].option
            }

            productInfo.variations && productInfo.variations.forEach(aVariation => {
                if (aVariation.attributes.length > 1) {
                    if (aVariation.attributes[0].option === firstValue && aVariation.attributes[1].option === secondValue) {
                        vafriationProduct = aVariation
                    }
                }
                else if (aVariation.attributes.length === 1) {
                    if (aVariation.attributes && aVariation.attributes[0].option === firstValue) {
                        vafriationProduct = aVariation
                    }
                }


            })
            if (vafriationProduct && productsInBag.includes(vafriationProduct.id)) {
                setIsProductInBag(true)
            }
            else if (productsInBag.includes(productInfo.id)) {
                setIsProductInBag(true)
            }
            else { setIsProductInBag(false) }
        })

    }

    const handleAddingToBag = (isProceed) => {
        let variationProductId = null
        if (variationProductData && variationProductData.id == undefined && productInfo.variations && productInfo.variations.length > 0) {
            variationProductId = productInfo.variations[0].id
        }
        else {
            variationProductId = variationProductData && variationProductData.id
        }
        let request = {}
        request = {
            "quantity": isVariationProduct ? variationProductQty : qtyInStock,
            "variationId": variationProductId
        }
        memberService.addProductsToBag(productInfo.id, request).then(response => {
            fetchProductsInBag()

            ToastsStore.success(t("Product added to bag successfully."));

            if (isProceed) {
                setProceedToCart(true)
            }
            else { setProceedToCart(false) }
        })

    }

    const handleRemovingFromBag = () => {
        memberService.removeProductsFromCart(productInfo.id).then(response => {
            ToastsStore.success(t("Product removed from bag successfully."));
            fetchProductsInBag()
        })
    }

    return (
        <>
            < >
                {isProceed && <Redirect to="/admin/bagDetail"></Redirect>}
                <Row >
                    <Col className="order-xl-1" xl="12">
                        <Card className="bg-white shadow">
                            <CardHeader className="bg-white border-0">
                                <Row className="d-flex mt--1" style={{ justifyContent: 'flex-end' }}>
                                    <Col xs="4" className="d-flex mt-2 " style={{ justifyContent: 'flex-end' }}>
                                        <p className="memberPointsLabel ">{t("My reward points")}:</p>
                                        <p className="memberPoints mt--1"> {memberPoints.totalPoints && memberPoints.totalPoints.toLocaleString()}</p>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs={6} className="d-flex justify-content-center">
                                        <Card><CardBody>
                                            {/* <a href="https://yamaha-lms-api-docs.s3.ap-southeast-1.amazonaws.com/privacy_policy.html">test</a> */}
                                            <div className="wrapper" style={{ cursor: 'pointer' }} >
                                                <img src={initialProductImage} alt="" height="449" width="500px" />
                                                {nextId !== 0 && <img src={back} className=" glyphiconProductImage fas fa-arrow-circle-left" onClick={handlePrev} alt="" />}
                                                {nextId < (productImageUrls.length - 1) && <img src={forward} style={{ marginLeft: '450px' }} className=" glyphiconProductImage fas fa-arrow-circle-right" onClick={handleNext} />}
                                            </div>
                                            {productInfo.isWishlisted && <svg class="Heart_wb" viewBox="0 0 16.667 15.833" onClick={() => clearWishList(productInfo)}>
                                                <path id="Heart_wb" d="M 8.360695838928223 15.8333740234375 L 8.360261917114258 15.83310699462891 L 8.144695281982422 15.69987392425537 C 6.243428707122803 14.52055740356445 4.457645416259766 13.12968349456787 2.836945772171021 11.56588268280029 C 1.724879026412964 10.44709968566895 0.8571124076843262 9.064274787902832 0.3274457454681396 7.566883563995361 C -0.1470208764076233 6.07997465133667 -0.1046625673770905 4.518874645233154 0.4466957747936249 3.171133041381836 C 1.029495716094971 1.746541738510132 2.15057897567749 0.7000249624252319 3.603445768356323 0.2243833392858505 C 3.844504117965698 0.1412916630506516 4.093812465667725 0.08274166285991669 4.344445705413818 0.05038333311676979 L 4.44419527053833 0.05038333311676979 C 4.67351245880127 0.01657499931752682 4.902687072753906 0.0001333333348156884 5.144695281982422 0.0001333333348156884 L 5.23619556427002 0.0001333333348156884 C 5.757145404815674 0.01575833186507225 6.270395755767822 0.1083666607737541 6.761695384979248 0.275383323431015 L 6.811195373535156 0.275383323431015 C 6.843303680419922 0.2907083332538605 6.869112014770508 0.3077999651432037 6.886195182800293 0.3248833119869232 C 7.101537227630615 0.3934416472911835 7.263561725616455 0.4605833292007446 7.411195278167725 0.5423833131790161 L 7.727695465087891 0.6833832859992981 C 7.804712295532227 0.7244249582290649 7.890103816986084 0.786591649055481 7.9654541015625 0.8414415717124939 C 8.013036727905273 0.8760749697685242 8.054120063781738 0.9059832692146301 8.086195945739746 0.9256333708763123 L 8.120253562927246 0.94549161195755 C 8.194378852844238 0.9885833263397217 8.27101993560791 1.033141732215881 8.335945129394531 1.083133339881897 C 9.262969970703125 0.3745416700839996 10.36012840270996 0 11.5077953338623 0 L 11.54443740844727 0.0001333333348156884 C 12.09517860412598 0.0001333333348156884 12.61676216125488 0.08164166659116745 13.09469509124756 0.2423833310604095 C 14.53219509124756 0.7096333503723145 15.64359569549561 1.750549912452698 16.22417068481445 3.173383235931396 C 16.76557922363281 4.500258445739746 16.81241989135742 6.101624965667725 16.35269546508789 7.566883563995361 C 15.82806205749512 9.073315620422363 14.96107006072998 10.45924949645996 13.84544563293457 11.57488346099854 C 12.23830413818359 13.13034152984619 10.46312046051025 14.52096557617188 8.569194793701172 15.70813274383545 L 8.361128807067871 15.83311653137207 L 8.360695838928223 15.8333740234375 Z M 12.45040416717529 2.598191499710083 C 12.16929626464844 2.598191499710083 11.91583728790283 2.779916524887085 11.81969547271729 3.050383329391479 C 11.70269584655762 3.400633335113525 11.88942050933838 3.785200119018555 12.23594570159912 3.907633066177368 C 12.76933765411377 4.107649803161621 13.12769603729248 4.633599758148193 13.12769603729248 5.21638298034668 L 13.12769603729248 5.241883277893066 C 13.11207008361816 5.431658267974854 13.16827011108398 5.61514949798584 13.28594493865967 5.758633136749268 C 13.39785289764404 5.894216537475586 13.57089614868164 5.982241630554199 13.76069641113281 6.000133037567139 C 14.10548782348633 5.991066455841064 14.39477825164795 5.712683200836182 14.4191951751709 5.366383075714111 L 14.4191951751709 5.267383098602295 C 14.44466209411621 4.101208209991455 13.73817825317383 3.042691469192505 12.66119575500488 2.633383274078369 C 12.5929126739502 2.610024929046631 12.52197933197021 2.598183393478394 12.45040416717529 2.598191499710083 Z">
                                                </path>
                                            </svg>}

                                            {!productInfo.isWishlisted && !isVariationProduct && <div className="d-flex glyphiconProductImage">
                                                <svg class="Path_33961_wb" viewBox="0 0 16.667 15.833" onClick={() => handleWishList(productInfo)}>
                                                    <path id="Path_33961_wb" d="M 8.360695838928223 15.8333740234375 L 8.360261917114258 15.83310699462891 L 8.144695281982422 15.69987392425537 C 6.243428707122803 14.52055740356445 4.457645416259766 13.12968349456787 2.836945772171021 11.56588268280029 C 1.724879026412964 10.44709968566895 0.8571124076843262 9.064274787902832 0.3274457454681396 7.566883563995361 C -0.1470208764076233 6.07997465133667 -0.1046625673770905 4.518874645233154 0.4466957747936249 3.171133041381836 C 1.029495716094971 1.746541738510132 2.15057897567749 0.7000249624252319 3.603445768356323 0.2243833392858505 C 3.844504117965698 0.1412916630506516 4.093812465667725 0.08274166285991669 4.344445705413818 0.05038333311676979 L 4.44419527053833 0.05038333311676979 C 4.67351245880127 0.01657499931752682 4.902687072753906 0.0001333333348156884 5.144695281982422 0.0001333333348156884 L 5.23619556427002 0.0001333333348156884 C 5.757145404815674 0.01575833186507225 6.270395755767822 0.1083666607737541 6.761695384979248 0.275383323431015 L 6.811195373535156 0.275383323431015 C 6.843303680419922 0.2907083332538605 6.869112014770508 0.3077999651432037 6.886195182800293 0.3248833119869232 C 7.101537227630615 0.3934416472911835 7.263561725616455 0.4605833292007446 7.411195278167725 0.5423833131790161 L 7.727695465087891 0.6833832859992981 C 7.804712295532227 0.7244249582290649 7.890103816986084 0.786591649055481 7.9654541015625 0.8414415717124939 C 8.013036727905273 0.8760749697685242 8.054120063781738 0.9059832692146301 8.086195945739746 0.9256333708763123 L 8.120253562927246 0.94549161195755 C 8.194378852844238 0.9885833263397217 8.27101993560791 1.033141732215881 8.335945129394531 1.083133339881897 C 9.262969970703125 0.3745416700839996 10.36012840270996 0 11.5077953338623 0 L 11.54443740844727 0.0001333333348156884 C 12.09517860412598 0.0001333333348156884 12.61676216125488 0.08164166659116745 13.09469509124756 0.2423833310604095 C 14.53219509124756 0.7096333503723145 15.64359569549561 1.750549912452698 16.22417068481445 3.173383235931396 C 16.76557922363281 4.500258445739746 16.81241989135742 6.101624965667725 16.35269546508789 7.566883563995361 C 15.82806205749512 9.073315620422363 14.96107006072998 10.45924949645996 13.84544563293457 11.57488346099854 C 12.23830413818359 13.13034152984619 10.46312046051025 14.52096557617188 8.569194793701172 15.70813274383545 L 8.361128807067871 15.83311653137207 L 8.360695838928223 15.8333740234375 Z M 12.45040416717529 2.598191499710083 C 12.16929626464844 2.598191499710083 11.91583728790283 2.779916524887085 11.81969547271729 3.050383329391479 C 11.70269584655762 3.400633335113525 11.88942050933838 3.785200119018555 12.23594570159912 3.907633066177368 C 12.76933765411377 4.107649803161621 13.12769603729248 4.633599758148193 13.12769603729248 5.21638298034668 L 13.12769603729248 5.241883277893066 C 13.11207008361816 5.431658267974854 13.16827011108398 5.61514949798584 13.28594493865967 5.758633136749268 C 13.39785289764404 5.894216537475586 13.57089614868164 5.982241630554199 13.76069641113281 6.000133037567139 C 14.10548782348633 5.991066455841064 14.39477825164795 5.712683200836182 14.4191951751709 5.366383075714111 L 14.4191951751709 5.267383098602295 C 14.44466209411621 4.101208209991455 13.73817825317383 3.042691469192505 12.66119575500488 2.633383274078369 C 12.5929126739502 2.610024929046631 12.52197933197021 2.598183393478394 12.45040416717529 2.598191499710083 Z">
                                                    </path>
                                                </svg>
                                            </div>}
                                            {!productInfo.isWishlisted && <div className="d-flex glyphiconProductImage">
                                                <svg class="Path_33961_wb" viewBox="0 0 16.667 15.833" onClick={() => handleWishList(productInfo)}>
                                                    <path id="Path_33961_wb" d="M 8.360695838928223 15.8333740234375 L 8.360261917114258 15.83310699462891 L 8.144695281982422 15.69987392425537 C 6.243428707122803 14.52055740356445 4.457645416259766 13.12968349456787 2.836945772171021 11.56588268280029 C 1.724879026412964 10.44709968566895 0.8571124076843262 9.064274787902832 0.3274457454681396 7.566883563995361 C -0.1470208764076233 6.07997465133667 -0.1046625673770905 4.518874645233154 0.4466957747936249 3.171133041381836 C 1.029495716094971 1.746541738510132 2.15057897567749 0.7000249624252319 3.603445768356323 0.2243833392858505 C 3.844504117965698 0.1412916630506516 4.093812465667725 0.08274166285991669 4.344445705413818 0.05038333311676979 L 4.44419527053833 0.05038333311676979 C 4.67351245880127 0.01657499931752682 4.902687072753906 0.0001333333348156884 5.144695281982422 0.0001333333348156884 L 5.23619556427002 0.0001333333348156884 C 5.757145404815674 0.01575833186507225 6.270395755767822 0.1083666607737541 6.761695384979248 0.275383323431015 L 6.811195373535156 0.275383323431015 C 6.843303680419922 0.2907083332538605 6.869112014770508 0.3077999651432037 6.886195182800293 0.3248833119869232 C 7.101537227630615 0.3934416472911835 7.263561725616455 0.4605833292007446 7.411195278167725 0.5423833131790161 L 7.727695465087891 0.6833832859992981 C 7.804712295532227 0.7244249582290649 7.890103816986084 0.786591649055481 7.9654541015625 0.8414415717124939 C 8.013036727905273 0.8760749697685242 8.054120063781738 0.9059832692146301 8.086195945739746 0.9256333708763123 L 8.120253562927246 0.94549161195755 C 8.194378852844238 0.9885833263397217 8.27101993560791 1.033141732215881 8.335945129394531 1.083133339881897 C 9.262969970703125 0.3745416700839996 10.36012840270996 0 11.5077953338623 0 L 11.54443740844727 0.0001333333348156884 C 12.09517860412598 0.0001333333348156884 12.61676216125488 0.08164166659116745 13.09469509124756 0.2423833310604095 C 14.53219509124756 0.7096333503723145 15.64359569549561 1.750549912452698 16.22417068481445 3.173383235931396 C 16.76557922363281 4.500258445739746 16.81241989135742 6.101624965667725 16.35269546508789 7.566883563995361 C 15.82806205749512 9.073315620422363 14.96107006072998 10.45924949645996 13.84544563293457 11.57488346099854 C 12.23830413818359 13.13034152984619 10.46312046051025 14.52096557617188 8.569194793701172 15.70813274383545 L 8.361128807067871 15.83311653137207 L 8.360695838928223 15.8333740234375 Z M 12.45040416717529 2.598191499710083 C 12.16929626464844 2.598191499710083 11.91583728790283 2.779916524887085 11.81969547271729 3.050383329391479 C 11.70269584655762 3.400633335113525 11.88942050933838 3.785200119018555 12.23594570159912 3.907633066177368 C 12.76933765411377 4.107649803161621 13.12769603729248 4.633599758148193 13.12769603729248 5.21638298034668 L 13.12769603729248 5.241883277893066 C 13.11207008361816 5.431658267974854 13.16827011108398 5.61514949798584 13.28594493865967 5.758633136749268 C 13.39785289764404 5.894216537475586 13.57089614868164 5.982241630554199 13.76069641113281 6.000133037567139 C 14.10548782348633 5.991066455841064 14.39477825164795 5.712683200836182 14.4191951751709 5.366383075714111 L 14.4191951751709 5.267383098602295 C 14.44466209411621 4.101208209991455 13.73817825317383 3.042691469192505 12.66119575500488 2.633383274078369 C 12.5929126739502 2.610024929046631 12.52197933197021 2.598183393478394 12.45040416717529 2.598191499710083 Z">
                                                    </path>
                                                </svg>
                                            </div>}
                                        </CardBody></Card>
                                    </Col>
                                    <Col xs={6}>
                                        <Card><CardBody>
                                            <p className="productTitleDetail mt-3">{productInfo.name}</p>
                                            <p className="productTitleDefinition mt-3">{productInfo.description && productInfo.description.replace(/<[^>]*>?/gm, '')}</p>
                                            {productInfo && productInfo.variations && productInfo.variations.length > 0 && <Row>
                                                <Col xs={6}>
                                                    <Dropdown isOpen={dropdownOpen1} toggle={toggle1}>
                                                        <DropdownToggle caret>
                                                            {selectedAttribute1 === null ? ("Select" + " " + productInfo.attributes[0].name) : (selectedAttribute1)}
                                                            {/* {attribute1List && attribute1List[0] && attribute1List[0].name} */}
                                                        </DropdownToggle>
                                                        <DropdownMenu>
                                                            {/* {selectedAttribute1 !== null ? <DropdownItem onClick={handleAttributeSelect}>Select </DropdownItem> : ""} */}
                                                            {attribute1List && attribute1List.map(anAttribute => {
                                                                return (<DropdownItem onClick={(event) => handleAttributeSelect(event, productInfo.attributes && productInfo.attributes[0] && productInfo.attributes[0].name, productInfo.attributes && productInfo.attributes[1] && productInfo.attributes[1].name)}>{anAttribute.name}</DropdownItem>)
                                                            })}
                                                        </DropdownMenu>
                                                    </Dropdown>
                                                </Col>

                                                {productInfo && productInfo.attributes && productInfo.attributes[1] && <Col xs={6}>
                                                    <Dropdown isOpen={dropdownOpen2} toggle={toggle2}>
                                                        <DropdownToggle caret>
                                                            {selectedAttribute2 === null ? ("Select" + " " + productInfo.attributes[1].name) : (selectedAttribute2)}
                                                            {/* {attribute2List && attribute2List[0] && attribute2List[0].name} */}

                                                        </DropdownToggle>
                                                        <DropdownMenu>
                                                            {/* {selectedAttribute2 !== null ? <DropdownItem onClick={handleAttribute1Select}>Select </DropdownItem> : ""} */}
                                                            {attribute2List && attribute2List.map(anAttribute => {
                                                                return (<DropdownItem onClick={(event) => handleAttribute1Select(event, productInfo.attributes[1].name, productInfo.attributes[0].name)}>{anAttribute.name}</DropdownItem>)
                                                            })}
                                                        </DropdownMenu>
                                                    </Dropdown>
                                                </Col>}
                                            </Row>}

                                            {showError && <Row>
                                                <Col xs="12">
                                                    <small style={{ color: 'red' }}>This variation is not available</small>
                                                </Col>
                                            </Row>}
                                            {variationProductData === null && <Row className="mt-6">
                                                <Col xs="4"><p className="productQuantityLabel">{t("Unit Points")}</p>
                                                   
                                                    {productInfo.prices.regular_price && productInfo.prices.sale_price && (productInfo.prices.regular_price !== productInfo.prices.sale_price) && 
                                                    <p className="mt--4" style={{ color: '#373A3C', fontSize: '20px', textDecoration: "line-through" }}>{productInfo.prices.regular_price}</p> ||
                                                    <p className="mt--4" style={{ color: '#373A3C', fontSize: '20px' }}>{productInfo.prices.regular_price}</p>
                                                   
                                                    }
                                                    {productInfo.prices.regular_price && productInfo.prices.sale_price && (productInfo.prices.regular_price !== productInfo.prices.sale_price) && 
                                                    <p className="mt--4" style={{ color: '#373A3C', fontSize: '20px' }}>{productInfo.prices.sale_price}</p>
                                                    }
                                                </Col>
                                                <Col xs="4">
                                                    <Button className="d-flex" style={{ backgroundColor: '#F5F8FA', height: '40px' }}>
                                                        <i className="fas fa-minus" style={{ color: '#97AABD', margin: '3px' }} onClick={handleReduceQty}></i>
                                                        <p className="mt--2 productQuantity" style={{ marginLeft: '10px', marginRight: '10px' }}>{parseInt(qtyInStock)}</p>
                                                        <i className="fas fa-plus" style={{ color: '#97AABD', margin: '3px' }} onClick={handleIncreaseQty}></i>
                                                    </Button></Col>
                                                <Col xs="4"><p className="productQuantityLabel">{t("Total Points")}</p>
                                                    
                                                    {productInfo.prices.regular_price && productInfo.prices.sale_price && (productInfo.prices.regular_price !== productInfo.prices.sale_price) && 
                                                    <p className="mt--4" style={{ color: '#373A3C', fontSize: '20px', textDecoration: "line-through" }}>{qtyInStock * productInfo.prices.regular_price}</p> ||
                                                    <p className="mt--4" style={{ color: '#373A3C', fontSize: '20px' }}>{qtyInStock * productInfo.prices.regular_price}</p>
                                                    }
                                                    {productInfo.prices.regular_price && productInfo.prices.sale_price && (productInfo.prices.regular_price !== productInfo.prices.sale_price) && 
                                                    <p className="mt--4" style={{ color: '#373A3C', fontSize: '20px' }}>{qtyInStock * productInfo.prices.sale_price}</p>
                                                    }
                                                </Col>
                                            </Row>}
                                            {isVariationProduct && variationProductData !== null && <Row className="mt-6">
                                                {/* {variationProductData.price} */}
                                                <Col xs="4"><p className="productQuantityLabel">{("Unit Points")}</p>
                                                    <p className="mt--4" style={{ color: '#373A3C', fontSize: '20px' }}>{variationProductData && variationProductData.sale_price ? variationProductData.sale_price : (variationProductData && variationProductData.regular_price ? variationProductData.regular_price : "")}</p>
                                                    {variationProductData && variationProductData.sale_price && <p className="mt--4" style={{ color: '#373A3C', fontSize: '20px', textDecoration: !variationProductData.sale_price ? "" : "line-through" }}>{variationProductData && variationProductData.regular_price}</p>}

                                                </Col>
                                                <Col xs="4">
                                                    <Button className="d-flex" style={{ backgroundColor: '#F5F8FA', height: '40px' }}>
                                                        <i className="fas fa-minus" style={{ color: '#97AABD', margin: '3px' }} onClick={handleReduceVariationQty}></i>
                                                        <p className="mt--2 productQuantity" style={{ marginLeft: '10px', marginRight: '10px' }}>{parseInt(variationProductQty)}</p>
                                                        <i className="fas fa-plus" style={{ color: '#97AABD', margin: '3px' }} onClick={handleIncreaseVariationQty}></i>
                                                    </Button></Col>
                                                <Col xs="4"><p className="productQuantityLabel">{t("Total Points")}</p>
                                                    {variationProductData && variationProductData.sale_price && <p className="mt--4" style={{ color: '#373A3C', fontSize: '20px' }}>{variationProductQty * variationProductData.sale_price}</p>}

                                                    {variationProductData && <p className="mt--4" style={{ color: '#373A3C', fontSize: '20px', textDecoration: !variationProductData.sale_price ? "" : "line-through" }}>{variationProductQty * variationProductData.regular_price}</p>}

                                                </Col>
                                            </Row>}
                                            <Row className="mt-3">
                                                <Col xs="12" className="d-flex" style={{ justifyContent: 'space-between' }}>
                                                    {!isProductInBag && productInfo.stockQuantity>0 && <Button color="primary" type="button" onClick={() => handleAddingToBag(false)} disabled={showError}>
                                                        {t("Add to cart")}
                                                    </Button>}
                                                    {isProductInBag && <Button color="primary" type="button" onClick={handleRemovingFromBag} disabled={showError}>
                                                        {t("Remove from cart")}
                                                    </Button>}
                                                    {productInfo.stockQuantity>0 && <Button color="primary" type="button" disabled={showError} onClick={() => handleAddingToBag(true)}>
                                                        {t("Proceed to checkout")}
                                                    </Button>}
                                                    {productInfo.stockQuantity<1 && <small style={{color:"red"}}>{t("Stock currently unavailable")}</small>}
                                                </Col>
                                            </Row>
                                        </CardBody></Card>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </>
        </>
    );
};

export default MyProductDetail;
